export default "__VITE_ASSET__C51vHINv__"